import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/services/api";

export interface ProgressEvent {
  id: string;
  title: string;
  comment?: string;
  updatedAt: string;
  transporterUpdate?: boolean;
  progressType?: string;
  user?: {
    firstName: string;
    lastName: string;
  };
}

async function fetchShippingProgress(
  listingId: string,
  filterType?: "vehicle" | "title"
): Promise<ProgressEvent[]> {
  const params: Record<string, string> = {};
  if (filterType) params.type = filterType;

  const token = localStorage.getItem("dockporter_token");
  const config: any = { params };
  if (token) config.headers = { Authorization: token };

  const res = await apiClient.get(`/shipments/${listingId}/progress`, config);
  // Handle both { data: [...] } and [...] response shapes
  const raw = res?.data?.data ?? res?.data ?? [];
  return Array.isArray(raw) ? raw : [];
}

export function useShippingProgress(
  listingId: string,
  filterType?: "vehicle" | "title"
) {
  return useQuery<ProgressEvent[]>({
    queryKey: ["shipping-progress", listingId, filterType],
    queryFn: () => fetchShippingProgress(listingId, filterType),
    enabled: !!listingId,
    staleTime: 60 * 1000,
  });
}
